module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-left/arrow-left-d1b146846f72d9d4d29bb5e430dd5d8a.svg";